import { BaseNestedFieldDefinition, ExtendedBaseProfileField } from '@stylehaven/components';

export function createMockProfileField(def: BaseNestedFieldDefinition): ExtendedBaseProfileField {
    return {
        FieldDefinition: def,
        FieldDefinitionId: def.FieldDefinitionId,
        DottedKey: def.DottedKey,
        ReadOnly: true,
        Required: false,
        Public: true,
        Labels: [],
        DisplayLabel: def.Label,
        Descriptions: []
    };
}
